/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getBraindatePath } from '@e180/domain/lib/braindate/util';

import VirtualBraindateReminderTakeOverDumb from './VirtualBraindateReminderTakeOverDumb';
import { forceVideoOverlay } from 'plugin/virtual-braindate/slice/virtualBraindateSlice';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';

import type { Braindate } from '@e180/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
  // Self passed
  history: Object,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => ({
  notification,
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  ownProps: Props,
): Object => {
  const { notification, history } = ownProps;
  // $FlowIssue
  const braindate: Braindate = getNotificationData(notification);

  return {
    ...stateProps,
    handleClick() {
      dispatch(dismissNotification(notification));
      dispatch(forceVideoOverlay(true));

      history.push(getBraindatePath(braindate));
    },
    handleDismiss() {
      dispatch(dismissNotification(notification));
    },
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(VirtualBraindateReminderTakeOverDumb);
